
<template>
  <div class="class-sandbox">
    <div class="container page-body text-center">
      <!-- <ToggleControl toggleId="abc">This is the ABC ToggleControl panel</ToggleControl> -->
      <ToggleControl toggleId="abc">Click to toggle section ABC</ToggleControl>
      <!-- <div v-b-toggle="'abc'"> -->
      <!-- <i :class="togglePanelIconClass"></i> {{ togglePanelText }} -->
      <!-- Section ABC toggle
      </div> -->

      <b-collapse id="abc"> This is content abc </b-collapse>
      <ToggleControl toggleId="def">Click to toggle section DEF</ToggleControl>
      <b-collapse id="def"> This is content def </b-collapse>
      <ToggleControl toggleId="ghi">Click to toggle section GHI</ToggleControl>
      <b-collapse id="ghi"> This is content ghi </b-collapse>

      <p>Sandbox page</p>
      <button class="btn btn-primary" @click="run">Run Code</button>
      <div class="textLoader">
        <div class="textLoader__text">Uploading</div>
        <div class="textLoader__periods">{{ periods }}</div>
      </div>
      <!-- <p>Loading{{ periods }}</p> -->
      <button class="btn btn-primary" @click="startPeriods">
        Start Periods
      </button>
      <button class="btn btn-primary" @click="stopPeriods">Stop Periods</button>
    </div>

    <div class="container page-body">
      <div class="alert-card alert-card--error">
        <div class="alert-card__icon alert-card__icon--error">
          <!-- <i class="fas fa-check-circle"></i> -->
          <i class="fas fa-exclamation-circle"></i>
        </div>
        <div class="alert-card__body">
          <div class="alert-card__header">Oops - There was a problem...</div>
          <!-- <div class="alert-card__header">Success - Image Uploaded!</div> -->
          <div class="alert-card__text">
            Your image was not uploaded because the upload service is
            temporarily down for maintenance. Please try again later.
          </div>
        </div>
      </div>
    </div>

    <div class="container page-body">
      <div class="test-image-wrapper">
        <div class="test-image">
          <!-- <img
          src="https://firebasestorage.googleapis.com/v0/b/book-images-mgr-dev.appspot.com/o/dogimgs%2F9lUqkYHIYlfJpkoLSFYByQhjDGy2%2Fthumbs%2Ffirst-time-bc-owner-tips-advice_200x200.jpg?alt=media&token=008b031e-6e80-477a-a7c4-a7dcd06411f3"
          alt=""
        /> -->
        </div>
      </div>

      <div class="alert-card alert-card--success">
        <div class="alert-card__icon alert-card__icon--success">
          <!-- <i class="fas fa-check-circle"></i> -->
          <i class="fas fa-check-circle"></i>
        </div>
        <div class="alert-card__body">
          <div class="alert-card__header">Success! Your image uploaded...</div>
          <!-- <div class="alert-card__header">Success - Image Uploaded!</div> -->
          <div class="alert-card__text">
            Your new image uploaded successfully. See info below.
          </div>
        </div>
      </div>
    </div>

    <div class="container page-body">
      <AlertCard
        :type="alert.type"
        :header="alert.header"
        :message="alert.message"
      />
    </div>
  </div>
</template>

<script>
var breedsObj = {
  afghanhnd: {
    breed: 'Afghan Hound',
    breedActual: 'Afghan Hound',
    breedGeneral: 'hound',
  },
  akita: { breed: 'Akita', breedActual: 'Akita', breedGeneral: 'akita' },
  alaskmal: {
    breed: 'Alaskan Malamute',
    breedActual: 'Alaskan Malamute',
    breedGeneral: 'alaskan malamute',
  },
  amereskimo: {
    breed: 'American Eskimo Dog',
    breedActual: 'American Eskimo Dog',
    breedGeneral: 'american eskimo dog',
  },
  auscat: {
    breed: 'Australian Cattle Dog',
    breedActual: 'Australian Cattle Dog',
    breedGeneral: 'australian cattle dog',
  },
  aussie: {
    breed: 'Australian Shepherd',
    breedActual: 'Australian Shepherd',
    breedGeneral: 'australian shepherd',
  },
  basenji: {
    breed: 'Basenji',
    breedActual: 'Basenji',
    breedGeneral: 'basenji',
  },
  bassethnd: {
    breed: 'Basset Hound',
    breedActual: 'Basset Hound',
    breedGeneral: 'hound',
  },
  beagle: { breed: 'Beagle', breedActual: 'Beagle', breedGeneral: 'beagle' },
  bernesemtn: {
    breed: 'Bernese Mountain Dog',
    breedActual: 'Bernese Mountain Dog',
    breedGeneral: 'bernese mountain dog',
  },
  bichonfrise: {
    breed: 'Bichon Frise',
    breedActual: 'Bichon Frise',
    breedGeneral: 'bichon frise',
  },
  bloodhnd: {
    breed: 'Bloodhound',
    breedActual: 'Bloodhound',
    breedGeneral: 'hound',
  },
  bordercollie: {
    breed: 'Border Collie',
    breedActual: 'Border Collie',
    breedGeneral: 'border collie',
  },
  boxer: { breed: 'Boxer', breedActual: 'Boxer', breedGeneral: 'boxer' },
  briard: { breed: 'Briard', breedActual: 'Briard', breedGeneral: 'briard' },
  brittany: {
    breed: 'Brittany',
    breedActual: 'Brittany',
    breedGeneral: 'brittany',
  },
  bulldogam: {
    breed: 'Bulldog - American',
    breedActual: 'American Bulldog',
    breedGeneral: 'bulldog',
  },
  bulldogeng: {
    breed: 'Bulldog - English',
    breedActual: 'Bulldog',
    breedGeneral: 'bulldog',
  },
  bulldogfr: {
    breed: 'Bulldog - French',
    breedActual: 'French Bulldog',
    breedGeneral: 'bulldog',
  },
  bullmastiff: {
    breed: 'Bullmastiff',
    breedActual: 'Bullmastiff',
    breedGeneral: 'mastiff',
  },
  chihuahua: {
    breed: 'Chihuahua',
    breedActual: 'Chihuahua',
    breedGeneral: 'chihuahua',
  },
  chowchow: {
    breed: 'Chow Chow',
    breedActual: 'Chow Chow',
    breedGeneral: 'chow chow',
  },
  collie: { breed: 'Collie', breedActual: 'Collie', breedGeneral: 'collie' },
  coonhound: {
    breed: 'Coonhound',
    breedActual: 'Coonhound',
    breedGeneral: 'coonhound',
  },
  corgi: { breed: 'Corgi', breedActual: 'Corgi', breedGeneral: 'corgi' },
  dachshund: {
    breed: 'Dachshund',
    breedActual: 'Dachshund',
    breedGeneral: 'dachshund',
  },
  dalmatian: {
    breed: 'Dalmatian',
    breedActual: 'Dalmatian',
    breedGeneral: 'dalmatian',
  },
  dobie: {
    breed: 'Doberman Pinscher',
    breedActual: 'Doberman Pinscher',
    breedGeneral: 'pinscher',
  },
  foxhound: {
    breed: 'Foxhound',
    breedActual: 'Foxhound',
    breedGeneral: 'foxhound',
  },
  germshep: {
    breed: 'German Shepherd',
    breedActual: 'German Shepherd',
    breedGeneral: 'german shepherd',
  },
  golden: {
    breed: 'Golden Retriever',
    breedActual: 'Golden Retriever',
    breedGeneral: 'golden retriever',
  },
  grdane: {
    breed: 'Great Dane',
    breedActual: 'Great Dane',
    breedGeneral: 'great dane',
  },
  grpyre: {
    breed: 'Great Pyrenees',
    breedActual: 'Great Pyrenees',
    breedGeneral: 'great pyrenees',
  },
  swissie: {
    breed: 'Greater Swiss Mountain Dog',
    breedActual: 'Greater Swiss Mountain Dog',
    breedGeneral: 'greater swiss mountain dog',
  },
  greyhound: {
    breed: 'Greyhound',
    breedActual: 'Greyhound',
    breedGeneral: 'greyhound',
  },
  greyhoundital: {
    breed: 'Greyhound - Italian',
    breedActual: 'Italian Greyhound',
    breedGeneral: 'greyhound',
  },
  huskyal: {
    breed: 'Husky - Alaskan',
    breedActual: 'Alaskan Husky',
    breedGeneral: 'husky',
  },
  huskysib: {
    breed: 'Husky - Siberian',
    breedActual: 'Siberian Husky',
    breedGeneral: 'husky',
  },
  irishwolfhnd: {
    breed: 'Irish Wolfhound',
    breedActual: 'Irish Wolfhound',
    breedGeneral: 'hound',
  },
  jackrt: {
    breed: 'Jack Russell Terrier',
    breedActual: 'Jack Russell Terrier',
    breedGeneral: 'russellterrier',
  },
  keeshond: {
    breed: 'Keeshond',
    breedActual: 'Keeshond',
    breedGeneral: 'keeshond',
  },
  labblack: {
    breed: 'Labrador Retriever - Black',
    breedActual: 'Labrador Retriever - Black',
    breedGeneral: 'labrador',
  },
  labchoc: {
    breed: 'Labrador Retriever - Chocolate',
    breedActual: 'Labrador Retriever - Chocolate',
    breedGeneral: 'labrador',
  },
  labyellow: {
    breed: 'Labrador Retriever - Yellow',
    breedActual: 'Labrador Retriever - Yellow',
    breedGeneral: 'labrador',
  },
  lhasaapso: {
    breed: 'Lhasa Apso',
    breedActual: 'Lhasa Apso',
    breedGeneral: 'lhasa apso',
  },
  maltese: {
    breed: 'Maltese',
    breedActual: 'Maltese',
    breedGeneral: 'maltese',
  },
  mastiff: {
    breed: 'Mastiff',
    breedActual: 'Mastiff',
    breedGeneral: 'mastiff',
  },
  minpin: {
    breed: 'Miniature Pinscher',
    breedActual: 'Miniature Pinscher',
    breedGeneral: 'pinscher',
  },
  mixed: { breed: 'Mixed', breedActual: 'Mixed', breedGeneral: 'mixed' },
  newfie: {
    breed: 'Newfoundland',
    breedActual: 'Newfoundland',
    breedGeneral: 'newfoundland',
  },
  papillon: {
    breed: 'Papillon',
    breedActual: 'Papillon',
    breedGeneral: 'papillon',
  },
  parsonrt: {
    breed: 'Parson Russell Terrier',
    breedActual: 'Parson Russell Terrier',
    breedGeneral: 'russellterrier',
  },
  pekingese: {
    breed: 'Pekingese',
    breedActual: 'Pekingese',
    breedGeneral: 'pekingese',
  },
  pointer: {
    breed: 'Pointer',
    breedActual: 'Pointer',
    breedGeneral: 'pointer',
  },
  pontergermsh: {
    breed: 'Pointer - German Shorthaired',
    breedActual: 'German Shorthaired Pointer',
    breedGeneral: 'pointer',
  },
  pommie: {
    breed: 'Pomeranian',
    breedActual: 'Pomeranian',
    breedGeneral: 'pomeranian',
  },
  poodlestd: {
    breed: 'Poodle - Standard',
    breedActual: 'Standard Poodle',
    breedGeneral: 'poodle',
  },
  poodletoy: {
    breed: 'Poodle - Toy',
    breedActual: 'Toy Poodle',
    breedGeneral: 'poodle',
  },
  portwater: {
    breed: 'Portuguese Water Dog',
    breedActual: 'Portuguese Water Dog',
    breedGeneral: 'portuguese water dog',
  },
  pug: { breed: 'Pug', breedActual: 'Pug', breedGeneral: 'pug' },
  rhodie: {
    breed: 'Rhodesian Ridgeback',
    breedActual: 'Rhodesian Ridgeback',
    breedGeneral: 'rhodesian ridgeback',
  },
  rottie: {
    breed: 'Rottweiler',
    breedActual: 'Rottweiler',
    breedGeneral: 'rottweiler',
  },
  stbern: {
    breed: 'Saint Bernard',
    breedActual: 'Saint Bernard',
    breedGeneral: 'saint bernard',
  },
  samoyed: {
    breed: 'Samoyed',
    breedActual: 'Samoyed',
    breedGeneral: 'samoyed',
  },
  schnauzgi: {
    breed: 'Schnauzer - Giant',
    breedActual: 'Giant Schnauzer',
    breedGeneral: 'schnauzer',
  },
  schnauzmin: {
    breed: 'Schnauzer - Miniature',
    breedActual: 'Miniature Schnauzer',
    breedGeneral: 'schnauzer',
  },
  schnauzstd: {
    breed: 'Schnauzer - Standard',
    breedActual: 'Standard Schnauzer',
    breedGeneral: 'schnauzer',
  },
  settereng: {
    breed: 'Setter - English',
    breedActual: 'English Setter',
    breedGeneral: 'setter',
  },
  settergord: {
    breed: 'Setter - Gordon',
    breedActual: 'Gordon Setter',
    breedGeneral: 'setter',
  },
  setterirish: {
    breed: 'Setter - Irish',
    breedActual: 'Irish Setter',
    breedGeneral: 'setter',
  },
  setteririshrw: {
    breed: 'Setter - Irish Red and White',
    breedActual: 'Irish Red and White Setter',
    breedGeneral: 'setter',
  },
  sharpei: {
    breed: 'Shar Pei',
    breedActual: 'Shar Pei',
    breedGeneral: 'shar pei',
  },
  sheepoeng: {
    breed: 'Sheepdog - Old English',
    breedActual: 'Old English Sheepdog',
    breedGeneral: 'sheepdog',
  },
  sheltie: {
    breed: 'Sheepdog - Shetland (Sheltie)',
    breedActual: 'Shetland Sheepdog',
    breedGeneral: 'sheepdog',
  },
  shibainu: {
    breed: 'Shiba Inu',
    breedActual: 'Shiba Inu',
    breedGeneral: 'shiba inu',
  },
  shihtzu: {
    breed: 'Shih Tzu',
    breedActual: 'Shih Tzu',
    breedGeneral: 'shih tzu',
  },
  spanielcavkc: {
    breed: 'Spaniel - Cavalier King Charles',
    breedActual: 'Cavalier King Charles Spaniel',
    breedGeneral: 'spaniel',
  },
  spanielckr: {
    breed: 'Spaniel - Cocker',
    breedActual: 'Cocker Spaniel',
    breedGeneral: 'spaniel',
  },
  spanielengckr: {
    breed: 'Spaniel - English Cocker',
    breedActual: 'English Cocker Spaniel',
    breedGeneral: 'spaniel',
  },
  spanielengspgr: {
    breed: 'Spaniel - English Springer',
    breedActual: 'English Springer Spaniel',
    breedGeneral: 'spaniel',
  },
  terrieraire: {
    breed: 'Terrier - Airedale',
    breedActual: 'Airedale Terrier',
    breedGeneral: 'terrier',
  },
  terrierborder: {
    breed: 'Terrier - Border',
    breedActual: 'Border Terrier',
    breedGeneral: 'terrier',
  },
  terrierboston: {
    breed: 'Terrier - Boston',
    breedActual: 'Boston Terrier',
    breedGeneral: 'terrier',
  },
  terrierbull: {
    breed: 'Terrier - Bull',
    breedActual: 'Bull Terrier',
    breedGeneral: 'terrier',
  },
  terriercairn: {
    breed: 'Terrier - Cairn',
    breedActual: 'Cairn Terrier',
    breedGeneral: 'terrier',
  },
  terrierfox: {
    breed: 'Terrier - Fox',
    breedActual: 'Fox Terrier',
    breedGeneral: 'terrier',
  },
  terrierirish: {
    breed: 'Terrier - Irish',
    breedActual: 'Irish Terrier',
    breedGeneral: 'terrier',
  },
  terrierkerryblue: {
    breed: 'Terrier - Kerry Blue',
    breedActual: 'Kerry Blue Terrier',
    breedGeneral: 'terrier',
  },
  terrierrat: {
    breed: 'Terrier - Rat',
    breedActual: 'Rat Terrier',
    breedGeneral: 'terrier',
  },
  terrierscott: {
    breed: 'Terrier - Scottish',
    breedActual: 'Scottish Terrier',
    breedGeneral: 'terrier',
  },
  terrierwestie: {
    breed: 'Terrier - West Highland White (Westie)',
    breedActual: 'West Highland White Terrier',
    breedGeneral: 'terrier',
  },
  terrierwheaten: {
    breed: 'Terrier - Wheaten',
    breedActual: 'Wheaten Terrier',
    breedGeneral: 'terrier',
  },
  terrieryorkie: {
    breed: 'Terrier - Yorkshire (Yorkie)',
    breedActual: 'Yorkshire Terrier',
    breedGeneral: 'terrier',
  },
  vizsla: { breed: 'Vizsla', breedActual: 'Vizsla', breedGeneral: 'vizsla' },
  weimar: {
    breed: 'Weimaraner',
    breedActual: 'Weimaraner',
    breedGeneral: 'weimaraner',
  },
  whippet: {
    breed: 'Whippet',
    breedActual: 'Whippet',
    breedGeneral: 'whippet',
  },
};

var qas = {
  10: {
    q:
      'How does this work? I mean, I upload photos of my dog and it helps other dogs in need?',
    a:
      "Yes! We create and publish wall calendars and journal and planner-type books. In general, we select 40-60 images for each project, selecting one (1) image each from as many of our Pixapup users. The images are captioned with the dog's name, owner's name or initials (their choice), and location (city, state/province, country). The published products are available for purchase world-wide and a portion of the proceeds goes direct to dog rescue groups, organizations, and shelters.",
  },
  15: {
    q:
      'When looking at my lists of photos (Uploads, Selected, etc.), some of the small thumbnail images seems slightly blurry. Should I be concerned? Should I re-upload?',
    a:
      "No need to do anything. When you upload your full-scale original image, a small thumbnail version of it is created. THAT is the image you see in your lists. Sometimes when a large image is converted to a much smaller one, the resulting small image can appear a little blurry; your original full-scale image is what we'll use in publication if your image is selected. By the way: We do this conversion to massively cut down on your data usage when viewing your images!",
  },
  20: {
    q: 'What types of products do you create?',
    a:
      "Wall calendars and journal/planner-type books. The calendars are printed in full color while the books use grayscale versions of the images. Each calendar or book contains 40-60 photos, each captioned with the dog's name, owner's name/initials, and location. Our amazing Pixapup users love and are proud having sharing their dog's image, knowing it's in a product available worldwide, AND knowing that calendar or book containing their photo will help dogs in need find their forever home!",
  },
  30: {
    q:
      'My image was selected and published in one of your calendars or books. Do I HAVE to buy it?',
    a:
      "Absolutely not! Signing up for a Pixapup account is free. There are no costs involved - ever. And there's no obligation whatsoever to purchase any published product in which your dog's image appears. Of course, we hope you do!  And we hope you'll tell your family and friends so that THEY might purchase. The products are available for purchase to anyone on the web and a portion of the proceeds for each product goes direct to dog rescue groups, organizations, and shelters to help dogs in need find their forever home!",
  },
  40: {
    q:
      "My photo is published with a caption including my name? What if I don't want my full name?",
    a:
      "No problem. Part of the appeal of our published products to our Pixapup family is that the calendars and books are \"personalized\" in the sense the each image is identified with a caption: The dog's name, sometimes the dog's breed (depending on the theme of the project), the owner's name, and their location: City, state/province, and country. For YOUR name, you can choose whether to have your first and last names in FULL, or your FULL first name and just your last name's initial. Example: Mary Smith or Mary S.",
  },
  50: {
    q:
      'The books and calendars you publish: Where are they available for purchase?',
    a:
      'Wall calendars are available on Lulu.com and books are available on Amazon.com. We might occasionaly create FULL-COLOR journal books and planners including spiral-bound and these editions will be on Lulu.com.',
  },
  60: {
    q:
      'Is it guaranteed my uploaded image will be selected for a calendar or book?',
    a:
      "For reasons of quality in the products we produce, we have Image Guidelines that a given image must adhere to if it's to be selected for a project. There are a couple of places within the Pixapup app where you can read those guidelines. If any one of your uploaded images meets the criteria, there's a good chance it will eventually be selected and published; otherwise it will be marked as 'Unusable'. You can see the status of any image from within the Pixapup app.",
  },
  70: {
    q:
      'How long will I have to wait to see if my uploaded image(s) is selected and published?',
    a:
      "It depends on our production schedule at any given time. It also depends on the breed. For example, if we're doing a calendar featuring a certain breed but for some reason do not have enough quality images to create the product, then your image will remain in your 'Uploads' list for a longer period of time than another image for which we have a lot to choose from among our many users.",
  },
  75: {
    q: 'How many photos can I upload?',
    a:
      "Over time, there's no limit to the number of photos you may upload. But you are limited to at most 10 at any given time. It works like this: You are given 10 *Upload Slots*. When you upload a photo, it occupies one of those slots. If you delete an uploaded photo, it frees up that slot for another upload. Similarly, when we select one of your photos for a project or mark a photo as 'Unusable', THAT upload slot becomes available. So, as long as you have slots available, which over time you will as they get filled then vacated, you can upload an unlimited number of photos.",
  },
  80: {
    q:
      'Today I uploaded 10 images. Will they all be selected for a book or calendar?',
    a:
      'Maybe! If they meet the Image Guidelines (see a question about that here on this page), they very well could all end up being selected and published in products at some point.',
  },
  90: {
    q:
      'If I upload, say 7 photos, and you select one of them for a book or calendar: Does that mean the remaining 6 photos will NOT be selected?',
    a:
      "Nope! Unless you absolutely want or need to delete an upload, you should leave any and all uploads you've done. Chances are, in time, we'll get to more of your images. And that means more of YOUR images end up in books and calendars available around the world! And a portion of the proceeds benefits rescue groups who need funds to operate to help the dogs in their care find their forever homes!",
  },
  100: {
    q:
      'How do I know if my uploaded photo was selected or published or marked as unusable?',
    a:
      "You can track all of your images easily from within the Pixapup app. There are four buttons near the top of every page, representing the four lists your images might appear in. You click that button to see the images in that list: Uploads, Selected, Published, Unusable. Each list has an overview describing what that list is all about. And our in-app guide explains it too. Also, unless you've opted out of email notifications, we will email you whenever any of your images are selected and published!",
  },
  110: {
    q:
      'My image was published in a calendar/book. How do I find out where to get the published product?',
    a:
      "When the product in which your image appears is published, we will notify you by email (unless you've opted out). That email will include the web address of the Amazon or Lulu page where the book is available for purchase. Also, at any time, you can view your list of 'Published' photos from within the Pixapup app. Please see the previous question/answer for more info.",
  },
  112: {
    q: 'Can my uploaded photos appear in more than one book or calendar?',
    a:
      'Yes! Please see the previous question/answer to see which of your photos is in which product.',
  },
  120: {
    q:
      'My dog has crossed the Rainbow Bridge. Can I, or should I, submit a photo of her?',
    a:
      "If you'd like to, yes. Many of our users have expressed the joy they can imagine - or actually felt - having their canine family member who has passed appear in one of our calendars or books. They look at it as a tribute to their dog(s). And, they veiw it as a legacy: It's a way to have their dog live on knowing that the book/calendar they appear in is potentially helping another dog in need find a loving family too!",
  },
  130: {
    q:
      'Are there content themes to the books and calendars you publish? Or are the photos in the books just some random selection?',
    a:
      'Most of the projects we create are breed-specific. Example: German Shepherds of the World: 2020 Wall Calendar. But sometimes, we\'ll create products in which the theme isn\'t breed-oriented but something else: Lovable Canines of Somewheretown, USA. In that example, the product can and will have photos spanning many breeds; the common theme is that they all reside in "Somewheretown."',
  },
  140: {
    q:
      'I run a dog rescue organization. Can I arrange with you to use Pixapup to handle the photo uploads for a book/calendar project specifically to benefit my organization?',
    a:
      'Yes! We can create a project just for you and have Pixapup users enter a special code on the upload form that associates their photo with your specific project. Please contact us to discuss further.',
  },
  150: {
    q: 'Where can I get a Pixapup t-shirt?',
    a:
      "They will be available soon... we'll let you know (and will update this answer too)!",
  },
};
console.log(Math.random());
import commonFields from '@/models/commonFieldsSchema';
import { Upload } from '@/models/Upload';

import { UploadPreferences } from '@/models/PreferencesUpload';
import { LayoutPreferences } from '@/models/PreferencesLayout';
import { NotificationPreferences } from '@/models/PreferencesNotification';

// console.log(LayoutPreferences.model);

// console.log('Upload imported:', Upload);
// import store from "../store";
// console.log("STORE", store);
import AlertCard from '@/components/notifications/AlertCard';

import ToggleControl from '@/components/layout/ToggleControl';

import { createLogger, mapGetters } from 'vuex';

import stateUtil from '@/helpers/stateUtil';

function doSomething() {
  return new Promise((res, rej) => {
    setTimeout(function () {
      res('done');
    }, 3000);
  });
}

function generatePeriods() {
  console.log('.');
}
function getTimerId() {
  return setInterval(generatePeriods, 500);
}

// var thePeriods = ['', '.', '..', '...', '....', '.....'];

// import { hello, anon } from '@/lib/test.js';
// console.log(anon('Dave'));
// import { hello } from '@/lib/test.js';
// import { anon } from '@/lib/test.js';
// console.log(anon('Gary'));
// import * as Test from '@/lib/test';
// console.log('Test obj', Test);
// console.log(Test.anon('Gary'));

function thumbFilename(sourceFilename, size) {
  const fileNameSizeSegment = `_${size}x${size}`;
  const re = /(\.\w+$)/;
  return sourceFilename.replace(re, fileNameSizeSegment + '$1');
}

function getThumbFileName(thumbnailSize, mainFilename) {
  // Get associated thumbnail file name for a given image filename
  // and size:  g1.jpg -->> 150px thumb filename = g1_150x150.jpg
  var fileNameSizeSegment = `_${thumbnailSize}x${thumbnailSize}`;
  var re = /(\.\w+$)/;
  var tnFilename = mainFilename.replace(re, fileNameSizeSegment + '$1');
  // At this point tnFilename has same path as object.name AND a modified basename.
  // Now, insert '/thumbs/' path segment between userId and basename
  var pathSegments = tnFilename.split(/[\\/]/);
  var baseName = pathSegments.pop();
  pathSegments.push('thumbs', baseName);
  tnFilename = pathSegments.join('/');
  return tnFilename;
}

export default {
  name: 'PageSandbox',
  components: {
    AlertCard,
    ToggleControl,
  },
  data: function () {
    return {
      abc: '',
      timerId: 0,
      count: 0,
      periods: '',
      alert: {
        type: '',
        header: '',
        message: '',
      },
      imageViewWidth: 0,

      queryStr: null,
    };
  },
  computed: {
    ...mapGetters('uploadTracker', ['imageCountsLoaded']),
    ...mapGetters('auth', ['authUser', 'isAuthenticated']),
    ...mapGetters(['numUploadTrackerChanges', 'userEnabled']),
  },
  methods: {
    generatePeriods: function () {
      var currentPeriods = this.periods;
      if (currentPeriods.length <= 5) {
        this.periods = currentPeriods + '.';
      } else {
        this.periods = '';
      }
    },
    startPeriods: function () {
      this.timerId = setInterval(this.generatePeriods, 200);
    },
    stopPeriods: function () {
      clearInterval(this.timerId);
    },

    viewObj: function (obj) {
      console.log('viewObj', obj);
    },

    // From functions/index.js ...
    parseFileName: function (fileName) {
      var rePathFileExt = /^([\w/]*?)([\w.-\s{}]*)\.(\w*)$/;
      var allSegments = fileName.match(rePathFileExt); // allSegments[0] contains fileName (the string being parsed)
      var segments = {
        // path: allSegments[1],
        // baseName: allSegments[2],
        // ext: allSegments[3],
        baseNameWithExt: '',
      };
      segments.baseNameWithExt = segments.baseName + '.' + segments.ext;
      return segments;
    },
    run: async function () {
      // console.log(breedsObj);

      // // Populate the breeds collection in the db
      // try {
      //   await this.$fapi.db.collection('breeds').doc('master').set({
      //     all: breedsObj,
      //   });
      // } catch (err) {
      //   console.error('Error setting dog breeds in db:', err.message);
      // }

      return;

      // var allUploads = this.$fapi.db.collection('imageUploads');
      // // .where('uid', '==', this.authUser.uid);
      // var uploadsSnapshot = await allUploads.get();
      // uploadsSnapshot.forEach((r) => {
      //   console.log(r.data().uid, r.id);
      // });
      // return;

      // var claimData = { email: 'gary.pajor@adelphia.net' };
      // var claimResult = await this.$fapi.firebase
      //   .functions()
      //   .httpsCallable('applyAdmin')(claimData);
      // console.log(claimResult);
      // return;

      // var myImgName = 'Gallon_Ziploc_box.JPG';
      // // var tfn = thumbFilename(myImgName, 200);
      // var tfn = getThumbFileName(200, myImgName.toLowerCase());
      // console.log(tfn);
      // return;

      // try {
      //   await this.$fapi.setDocument('users', 'uidGaryTest5', {
      //     fName: 'Gary',
      //     lName: 'Testx',
      //     agreeTermsPrivacy: true,
      //     agreeCookies: true,
      //     agreeEmailNotify: true,
      //     createdAt: this.$fapi.firebase.firestore.FieldValue.serverTimestamp(),
      //     creTime: Date.now(),
      //     enabled: true,
      //     navBarSticky: true,
      //     showWelcomeBar: true,
      //   });
      // } catch (err) {
      //   console.error(err.message);
      // }
      // return;

      // console.log(
      //   LayoutPreferences.model,
      //   UploadPreferences.model,
      //   NotificationPreferences.model
      // );
      // var myPrefs = {
      //   // fName,
      //   // lName,
      //   // agreeTermsPrivacy,
      //   // agreeCookies,
      //   // agreeEmailNotify,
      //   createdAt: this.$fapi.firebase.firestore.FieldValue.serverTimestamp(),
      //   creTime: Date.now(),
      //   enabled: true,
      //   ...LayoutPreferences.model,
      // };
      // return;

      // var userRef = this.$fapi.db
      //   .collection('users')
      //   .doc('eHLwhbnjG7Y3xAARbbBOyNJePfj2'); // eHLwhbnjG7Y3xAARbbBOyNJePfj2
      // // var myUpload = await myUploadRef.get();
      // // console.log(myUpload.data());
      // var updatedUser = {
      //   // fName: 'Gary',
      //   // lName: 'smith',
      //   dogName: 'Sally',
      //   fName: 'Garwald',
      //   enabled: true,
      //   // state: 'NM',
      //   // agreeTerms: true,
      // };

      // var userDoc = await userRef.get();
      // console.log(userDoc.data());
      // // return;
      // try {
      //   await userRef.update(updatedUser);
      // } catch (err) {
      //   console.error(err.message);
      // }
      // userDoc = await userRef.get();
      // console.log(userDoc.data());
      // return;

      // 'MS4DujV3QpPAuy4WzuR9' QxA0DE0jmgEqQeoRqjNu

      // var person = { name: 'Gary <b>bold</b>', title: 'drummer', active: true };
      // var saniPerson = { name: 'Cleanedxxx Gary', title: 'cleaned drummer' };
      // var clean = { ...person, ...saniPerson };
      // console.log(clean);
      // return;

      var myUploadRef = this.$fapi.db
        .collection('imageUploads')
        .doc('Pm1qF3IBBO02xwCmtTrM');
      var myUploadBefore = await myUploadRef.get();
      console.log(myUploadBefore.data());
      var updatedUpload = {
        updatedAt: this.$fapi.firebase.firestore.FieldValue.serverTimestamp(),
        fName: '    Gary <b>shit all bold</b>             ',
        imageURL: '<strong>YESH',
        // lName: 'Pajor',
        // breed: 'Afghan Hound',
        // state: 'NM',
        // agreeTerms: true,
        // uid: 'xx',
        // usageStatus: 'pending',
        // imageThumbURL: 'http://image.com/i.jpg',
      };
      try {
        await myUploadRef.update(updatedUpload);
      } catch (err) {
        console.error(err.message);
      }
      var myUpload = await myUploadRef.get();
      console.log(myUpload.data());
      return;

      var drumRef = this.$fapi.db.collection('drums').doc('snare');
      // var drumRef = this.$fapi.db
      //   .collection('imageUploads')
      //   .doc('ZFTWeaE86JBrLfZc1kYg');
      var snare = await drumRef.get();

      var updatedDrumObj = {
        updatedAt: this.$fapi.firebase.firestore.FieldValue.serverTimestamp(),
        // size: 99,
        color: 'redx',
        type: 'beginner',
        condition: 'usedx',
        make: 'Pear',
        age: 'whatever',
        // name: 'Gary',
        // hasCymbals: false,
        agreeTerms: true,
        projects: 'many',
      };
      console.log(updatedDrumObj);
      try {
        await drumRef.update(updatedDrumObj);
      } catch (err) {
        console.error(err.message);
      }
      snare = await drumRef.get();
      console.log(snare.data());

      return;

      // var funkyFilename =
      //   'borderCollie-greatSmile--pexels-nikola-čedíková-5379724.jpg';

      // // var regex = /[^-_.a-z0-9]/gi;
      // var regex = /[^-.\w]/gi;
      // // funkyFilename = funkyFilename.replace(regex, '');
      // console.log(this.parseFileName(funkyFilename));
      // // console.log(funkyFilename);
      // return;

      // console.log(qas);
      // // Populate the faqs collection in the db
      // try {
      //   await this.$fapi.db.collection('faqs').doc('master').set({
      //     all: qas,
      //   });
      // } catch (err) {
      //   console.error('Error setting faqs in db:', err.message);
      // }
      // return;

      return console.log(this.authUser);

      var qa = ['qa5', 'qa20', 'qa3', 'qa11', 'qa2'];
      // var qa = [5, 20, 3, 11, 2];
      console.log(
        qa.sort(function (a, b) {
          return a - b;
        })
      );
      return;

      var numSignups = '';
      try {
        numSignups = await this.$fapi.firebase
          .functions()
          .httpsCallable('getNumReferredSignups')();
      } catch (err) {
        console.error(err.message);
      }

      console.log(numSignups.data);
      return;
      // console.log(Math.random());
      // return;

      var ua = this.$fapi.db
        .collection('imageUploads')
        .where('usageStatus', '==', 'published');
      var as = await ua.get();
      as.forEach((r) => {
        console.log(r.data().uid);
      });

      return;

      var messageObj = {
        uid: 'xxx',
        subject: 'Sandbox',
        message: 'app is down text',
        // createdAt: this.$fapi.firebase.firestore.FieldValue.serverTimestamp(),
      };

      try {
        await this.$fapi.firebase.functions().httpsCallable('inAppContact')(
          messageObj
        );
      } catch (err) {
        console.error(err.message);
      }

      console.log('done');
      return;
      // getAllContexts() {
      //         var allContexts = [];
      //         this.getProps().forEach(prop => {
      //             allContexts = [...allContexts, ...this.getContext(prop, true)]
      //         })
      //         // Dedupe allContexts
      //         return allContexts.reduce((a, c) => {
      //             if (a.includes(c)) {
      //                 return a
      //             }
      //             return a.concat(c);
      //         }, []);
      //     }

      // var check = { a: 'a', b: 'b', c: 'asf', d: '34', f: 'g' };
      // var checkProps = ['a', 'b', 'c', 'd'];
      // // Check data type of each property -- they all must be of stype 'string'
      // var isValid = checkProps.reduce((a, prop) => {
      //   return a && typeof check[prop] === 'string';
      // }, true);
      // // ********* WORKS
      // // All prop values must be non-empty
      // var dataValidated = Object.keys(check).reduce((a, prop) => {
      //   return a && check[prop] !== '';
      // }, true);
      // console.log(isValid && dataValidated);
      // return;

      // var newUser = {
      //   fname: 'g',
      //   lname: 'p',
      //   // ...LayoutPreferences.model,
      // };
      // this.viewObj({ dog: 'Taylor', fun: true, ...LayoutPreferences.model });
      // // console.log(newUser);
      // return;

      var theMail = {
        from: 'Pixapup App Support <supportca@pixapup.com>',
        to: 'support@pixapup.com',
        // subject: 'Sample ...',
        replyTo: 'gary.pajor@gmail.com',
        // text:
        //   'Welcome to Pixapup! Please go here to login: https://app.pixapup.com/login',
        // html: `<html><body><strong>Hello</strong> and welcome to Pixapup!
        // <p>Please go here to login: https://app.pixapup.com/login</p>
        // <p><a href="https://app.pixapup.com/login">Login here</a>.</p>
        // <p>Thank you!</p>
        // </body></html>`,
        templateId: 21309638,
        templateModel: {
          fname: 'Gary',
        },
      };

      theMail = {
        from: 'Pixapup App Support <supportca@pixapup.com>',
        to: 'support@pixapup.com',
        subject: 'Testing from sandbox',
        text: 'Some text for the message.',
        replyTo: 'gary.pajor@gmail.com',
      };
      var sendMailRes = await this.$fapi.firebase
        .functions()
        .httpsCallable('sendMail')(theMail);
      console.log(sendMailRes);
      // const serverToken = '17e3dca8-8460-4322-b0c1-ab7a38acbef2';

      return;

      var xxx = this.$fapi.db
        .collection('imageUploads')
        // .where('uid', '==', this.authUser.uid)
        .where('note', '>', '');
      // .where('usageStatus', '==', 'pending');
      var xxxSnapshot = await xxx.get();

      // console.log(uSnapshot.docs[0].get('breed'));
      console.log(xxxSnapshot.size);

      for (var ii = 0; ii < xxxSnapshot.docs.length; ii++) {
        console.log(xxxSnapshot.docs[ii].id, xxxSnapshot.docs[ii].data().note);
      }

      return;
      var drum = { make: '', size: 12, type: undefined };
      // if (drum.type === '' || drum.type === undefined || drum.type === null) {
      //   console.log('Type is required!');
      // } else {
      //   console.log('ok drum obj');
      // }
      console.log(drum.make.toLowerCase());
      return;
      if (drum.type !== '' && drum.type !== undefined && drum.type !== null) {
        console.log('Type was filled in so needs to be checked');
      } else {
        console.log('Type was NOT filled in');
      }

      return;
      var projectCode = 'sc-colchcolchcolchcog';
      // Check if valid format for referral code
      if (/^sc-[a-z0-9]{5,20}$/i.test(projectCode)) {
        console.log('Valid code');
      } else {
        console.log('INVALID code');
      }
      return;

      console.log('user enabled?', this.userEnabled);
      return;
      // // ----- DELETE all referrals docs (except one)
      // var referralsSnapshot = await this.$fapi.db.collection('referrals').get();

      // // Reference: https://stackoverflow.com/questions/47876754/query-firestore-database-for-document-id
      // // var referralsSnapshot = await this.$fapi.db
      // //   .collection('referrals')
      // //   .where(
      // //     // this.$fapi.firebase.firestore.FieldPath.documentId(), // works
      // //     '__name__', // works
      // //     '<',
      // //     'par4-hu3mp'
      // //   )
      // //   .get();
      // console.log(referralsSnapshot.size);
      // referralsSnapshot.forEach((doc) => {
      //   if (doc.id !== 'par4-hu3mp') {
      //     doc.ref.delete();
      //     console.log('Deleted doc:', doc.id);
      //   }
      // });
      // //

      // return;

      // var nn = Date.now();
      // console.log(Date().toLocaleString());
      // console.log(Date().toString());
      // return;

      // await this.$fapi.setDocument('ipPool', '223.43.1.228', {
      //   valid: false,
      //   count: 27,
      // });
      // console.log('Done');
      // var u = this.$fapi.db
      //   .collection('imageUploads')
      //   .where('uid', '==', this.authUser.uid);

      // var myUserDoc = await this.$fapi.db
      //   .collection('users')
      //   .doc(this.authUser.uid)
      //   .get();
      // console.log(myUserDoc.data().createdAt.valueOf());
      // return;
      try {
        var testResult = await this.$fapi.firebase
          .functions()
          .httpsCallable('finalizeNewUser')({
          uid: 'M6vqQnM0QCM2tUrCO2T9N64yUEq2',
          refBy: 'par5-hu3mp',
          email: 'test@a.com',
        }); // test function name: test
        console.log(testResult);
      } catch (err) {
        console.error(err.message);
      }
      return;

      var referralCode = 'par1-w3h6p';
      // Check if valid format for referral code
      if (/^par[2-9]-[a-z2-9]{5}$/i.test(referralCode)) {
        console.log('Valid code');
      } else {
        console.log('INVALID code');
      }
      return;

      function randNum(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }
      function genReferralCode() {
        var charPool = 'bcdefghijkmnprtwxy23456789'; // character pool
        var randCharStr = Array.from(
          { length: 5 },
          (c) => charPool[randNum(0, charPool.length - 1)]
        ).join('');
        return `par${randNum(2, 9)}${randCharStr}`;
      }

      // var ra = Array.from({ length: 50 }, (i) => randNum(2, 9));
      // ra.sort((a, b) => a - b);
      // console.log(ra);
      var rc = Array.from({ length: 10 }, (code) => genReferralCode());
      console.log(rc);
      return;

      console.log(this.authUser.uid);
      var u = this.$fapi.db
        .collection('imageUploads')
        .where('uid', '==', this.authUser.uid);
      // .where('usageStatus', '==', 'pending');
      var uSnapshot = await u.get();

      // console.log(uSnapshot.docs[0].get('breed'));
      console.log(uSnapshot.size);

      // for (var i = 0; i < uSnapshot.docs.length; i++) {
      //   console.log(uSnapshot.docs[i].data().dogName);
      // }
      var i = [];
      for (var doc of uSnapshot.docs) {
        i.push(doc.data().imageFilename);
        // console.log(doc.data().imageFilename);
        if (doc.data().usageStatus === 'pending') {
          console.log(doc.id);
          await doc.ref.update({
            test: 123,
            updatedAt: this.$fapi.firebase.firestore.FieldValue.serverTimestamp(),
          });
        }
      }

      // console.log(i);
      // or:
      // uSnapshot.forEach((doc) => console.log(doc.data()));
      return;

      // ---------------

      // db.collection("cities").where("capital", "==", true).get()
      var q = this.$fapi.db.collection('projects').where('active', '==', false); // testing (dummy field: 'active');
      //.where('uids', 'array-contains', 'DPkrWNXdgZUliesQNVL0HTlNY0p2'); //
      try {
        var querySnapshot = await q.get();
        // console.log('# results:', querySnapshot.docs.length);
        querySnapshot.forEach((doc) => {
          var uploadIds = doc.data().uploadIds;
          console.log('Project Id:', doc.id);
          console.log('Upload Ids:', uploadIds);
          // uploadIds.forEach((uploadId) => {
          //   console.log(this.$fapi.getDocById('imageUploads', uploadId));
          // });
        });
      } catch (err) {
        console.error(err.message);
      }

      return;

      // ------------

      function generateRandom(maxInclusive) {
        return Math.floor(Math.random() * (maxInclusive + 1));
      }

      console.log(Array.from({ length: 10 }));
      var letterPool = 'abcdefghijkmnpqrstuvwxyz23456789';
      var a = Array.from(
        { length: 5 },
        (i) => letterPool[generateRandom(letterPool.length - 1)]
      ).join('');
      console.log(a);

      return;

      try {
        await this.authUser.updateEmail('dwightabc@smith.com');
        console.log('Success - email changed. User:', this.authUser);
      } catch (err) {
        console.error(
          'Failed - email NOT changed:',
          err.message,
          this.authUser
        );
        // Possible error msg: The email address is already in use by another account.
        // ... and, the one requiring logout then login again:
        //        This operation is sensitive and requires recent authentication. Log in again before retrying this request.
      }

      return;

      // console.log('FAPI user', this.$fapi.auth.currentUser);
      // console.log('user stored in state', this.authUser);

      // // const serverToken = '17e3dca8-8460-4322-b0c1-ab7a38acbef2';
      // const serverToken = 'POSTMARK_API_TEST';

      // let postmark = require('postmark');
      // let client = new postmark.ServerClient(serverToken);
      // console.log(postmark);
      // console.log(client);

      // try {
      //   await client.sendEmail({
      //     From: 'welcom@pixapup.com',
      //     To: 'gary.pajor@gmail.com',
      //     Subject: 'Welcome to Pixapup!',
      //     HtmlBody: 'Hello message body.',
      //     TextBody: 'Hello there - this is the message body.',
      //   });
      // } catch (err) {
      //   console.error(err.message);
      // }

      return;

      // function random() {
      //   return Promise.resolve(Math.floor(Math.random() * 10));
      //   // return Math.floor(Math.random() * 10);
      // }

      // async function sumRandom() {
      //   var r1 = await random();
      //   var r2 = await random();
      //   console.log('r1', r1, 'r2', r2);
      //   return r1 + r2;
      // }
      // // sumRandom().then(console.log);
      // // console.log('SUM:', await sumRandom());
      // return;

      try {
        await this.authUser.updateEmail('simon@smith.com');
        console.log('Success - email changed. User:', this.authUser);
      } catch (err) {
        console.error(
          'Failed - email NOT changed:',
          err.message,
          this.authUser
        );
        // Possible error msg: The email address is already in use by another account.
        // ... and, the one requiring logout then login again:
        //        This operation is sensitive and requires recent authentication. Log in again before retrying this request.
      }

      return;

      // var imageUploadRef = this.$fapi.getDocRefById(
      //   'imageUploads',
      //   'vjXcpaXQ2YluCqAzkQ7I'
      // );

      // try {
      //   await imageUploadRef.update({
      //     lName: 'Smith',
      //     // usageStatus: 'pending',
      //   });
      //   console.log('Edit succeeded.');
      // } catch (err) {
      //   console.error(err.message);
      // }

      // return;

      // Signed in as 'fake' admin (for now 'fake').
      // Create a project.
      var uploadTrackerProj = {
        creTime: Date.now(),
        title: 'Real Border Collies of the World Vol. 1: 2021 Calendar',
        platform: 'Lulu',
        url: 'https://lulu.com',
        // title: 'Gratitude Journal Vol. 1 for Border Collie Lovers',
        // platform: 'Amazon',
        // url: 'https://amazon.com',
      };
      var project = {
        createdAt: this.$fapi.firebase.firestore.FieldValue.serverTimestamp(),
        uids: ['DPkrWNXdgZUliesQNVL0HTlNY0p2'],
        uploadIds: ['DZ8842rTzmkvhjvYxvu3'],
      };

      project = { ...project, ...uploadTrackerProj };
      console.log('Project:', project);

      try {
        var projDocRef = await this.$fapi.addDocument('projects', project);
        var projId = projDocRef.id;
        uploadTrackerProj.projId = projId;
        try {
          var uploadDocRef = await this.$fapi.getDocRefById(
            'imageUploads',
            'DZ8842rTzmkvhjvYxvu3'
          );
          // WHAT ABOUT numProjects on the imageUpload document ??????????????????????????????????
          await uploadDocRef.update({
            usageStatus: 'published', // don't need this each time, e.g. maybe adding a project to an already-published upload
            updatedAt: this.$fapi.firebase.firestore.FieldValue.serverTimestamp(),
            projects: this.$fapi.firebase.firestore.FieldValue.arrayUnion(
              uploadTrackerProj
            ),
          });
          console.log('Project added!!!');
        } catch (error) {
          console.error('Update imageUploads Doc Error:', error.message);
        }
      } catch (error) {
        console.error('Create New Project Error:', error.message);
      }

      // Assign it to an imageUpload
      // washingtonRef.update({
      //     regions: firebase.firestore.FieldValue.arrayUnion("greater_virginia")
      // });
      // getDocById('imageUploads','DZ8842rTzmkvhjvYxvu3')

      return;

      try {
        // ALL properties shown are REQUIRED; otherwise create op fails security rules
        var messageRef = await this.$fapi.addDocument('messages', {
          uid: this.authUser.uid,
          email: this.authUser.email,
          createdAt: this.$fapi.firebase.firestore.FieldValue.serverTimestamp(),
          subject: 'Image problem',
          message:
            'How do I upload an image? Him seas air fly bring cant given theyre he be own the dry moving upon together created greater divided. Yielding saw shall tree. A after was moving wherein hath.',
        });
        console.log(
          'New doc added to messages collection. Message doc id:',
          messageRef.id
        );
      } catch (err) {
        console.error(err.message);
      }

      var breeds = {
        mixed: 'Mixed',
        bordercollie: 'Border Collie',
        labrador: 'Labrador Retriever',
        collie: 'Collie',
        sheltie: 'Sheltie',
        poodle: 'Poodle',
        dachshund: 'Dachshund',
        beagle: 'Beagle',
        germanshepherd: 'German Shepherd',
        setter: 'Setter',
        pitbull: 'Pitbull',
        goldenretriever: 'Golden Retriever',
        rottweiler: 'Rottweiler',
        papillon: 'Papillon',
      };

      // Populate the breeds collection in the db
      // try {
      //   await this.$fapi.db.collection('breeds').doc('master').set({
      //     all: breeds,
      //   });
      // } catch (err) {
      //   console.error('Error setting dog breeds in db:', err.message);
      // }

      var sortedByBreedTuples = Object.keys(breeds)
        .map((breedCode) => [breedCode, breeds[breedCode]])
        .sort((a, b) => (a[1] > b[1] ? 1 : -1));
      // console.log(sortedByBreedTuples);

      // var imageViewPort = document.querySelector('.test-image');
      // this.imageViewWidth += 10;
      // imageViewPort.style.width = this.imageViewWidth + 'px';

      // console.log('Num uploadTrackerChanges', this.numUploadTrackerChanges);
      // this.$store.dispatch('incNumUploadTrackerChanges');
      // this.$store.dispatch('setUploadInProgress', true);
      // if (this.numUploadTrackerChanges > 4) {
      //   this.$store.dispatch('resetNumUploadTrackerChanges');
      // }

      // var result = await doSomething();
      // console.log('result', result);
      // console.log('doSomething finished');
      // console.log(this.authUser.uid);
      // stateUtil.initState(this.$store, this.$fapi);
      // console.log('imageCounts loaded?', this.imageCountsLoaded);
      // console.log(
      //   'authenticated user exists:',
      //   this.isAuthenticated,
      //   this.authUser.uid,
      //   this.authUser.email
      // );
    },
  },

  created() {
    // console.log(this.$route);

    // console.log("hi there");
    var alertObj = {
      type: 'error',
      header: 'Huge problem',
      message:
        'We are doomed!! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Necessitatibus molestias beatae repellat veniam, assumenda repellendus voluptates cupiditate est! Nemo, necessitatibus.',
    };
    this.alert = alertObj;
  },
};
</script>

<style>
.test-image-wrapper {
  width: 200px;
  margin: 1rem auto;
  /* border: 1px solid red; */
}
.test-image {
  /* margin: 1rem auto; */
  width: 0;
  height: 200px;
  /* border: 1px solid blue; */
  text-align: center;
  background: no-repeat
    url('https://firebasestorage.googleapis.com/v0/b/book-images-mgr-dev.appspot.com/o/dogimgs%2F9lUqkYHIYlfJpkoLSFYByQhjDGy2%2Fthumbs%2Ffirst-time-bc-owner-tips-advice_200x200.jpg?alt=media&token=008b031e-6e80-477a-a7c4-a7dcd06411f3');
}
</style>

